(()=>{
  const money=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'});
  const clean=v=>(v||'').toString().trim();
  const PHRASE_SHORT_VARIANT=41227194368049;
  const PHRASE_LONG_VARIANT=41227194335281;

  function init(root){
    if(root.dataset.lfReady==='true')return;
    root.dataset.lfReady='true';

    const formId=root.dataset.formId;
    const form=document.getElementById(formId);
    if(!form)return;

    let variants=[];
    try{variants=JSON.parse(root.querySelector('[data-lf-variants]')?.textContent||'[]')}catch(e){}

    const toggles=[...root.querySelectorAll('[data-addon-toggle]')];
    const error=root.querySelector('[data-lf-customizer-error]');
    const baseEl=root.querySelector('[data-lf-base-price]');
    const addonEl=root.querySelector('[data-lf-addon-total]');
    const grandEl=root.querySelector('[data-lf-grand-total]');
    const isBrazil=/brasil/i.test(root.dataset.productTitle||'');
    const selected=key=>root.querySelector(`[data-addon-toggle="${key}"]`)?.checked;
    const input=key=>root.querySelector(`[data-addon-input="${key}"]`);
    const card=key=>root.querySelector(`[data-addon="${key}"]`);
    const currentVariant=()=>{
      const id=form.querySelector('[name="id"]')?.value;
      return variants.find(v=>String(v.id)===String(id))||variants.find(v=>v.available)||variants[0];
    };

    const phraseInput=input('phrase');
    const phraseCard=card('phrase');
    const phraseHelper=root.querySelector('[data-addon-field="phrase"] span');
    const phraseSmall=phraseCard?.querySelector('.lf-addon__copy small');
    const headText=root.querySelector('.lf-paid-customizer__head p');
    const badge=root.querySelector('.lf-paid-customizer__badge');

    if(phraseInput){
      phraseInput.maxLength=130;
      phraseInput.placeholder='Digite sua frase (até 130 caracteres)';
    }

    if(isBrazil){
      if(phraseSmall) phraseSmall.textContent='Personalização grátis nas camisas do Brasil';
      if(headText) headText.textContent='Camisa do Brasil: nome, número e frase sem custo adicional.';
      if(badge) badge.textContent='GRÁTIS';
    }else{
      if(phraseSmall) phraseSmall.textContent='Até 80 caracteres: R$ 70 · 81 a 130: R$ 100';
      if(headText) headText.textContent='Escolha o que quiser adicionar. Nome + número sai por R$ 50. Na opção frase, nome e número podem ser incluídos sem custo extra.';
    }

    function phraseLength(){return clean(phraseInput?.value).length}
    function phrasePrice(){return phraseLength()>80?10000:7000}
    function priceLabel(key,text){
      const el=card(key)?.querySelector('.lf-addon__choice b');
      if(el)el.textContent=text;
    }

    function update(){
      const phraseOn=!!selected('phrase');
      let extra=0;

      toggles.forEach(t=>{
        const key=t.dataset.addonToggle;
        const field=root.querySelector(`[data-addon-field="${key}"]`);
        if(field)field.hidden=!t.checked;
        if(!t.checked||isBrazil)return;

        if(key==='phrase'){
          extra+=phrasePrice();
        }else if(!phraseOn){
          extra+=key==='number'?2000:Number(t.closest('[data-price]')?.dataset.price||0);
        }
      });

      if(isBrazil){
        priceLabel('phrase','GRÁTIS');
        priceLabel('name','GRÁTIS');
        priceLabel('number','GRÁTIS');
      }else{
        priceLabel('phrase',phraseLength()>80?'+ R$ 100':'+ R$ 70');
        priceLabel('name',phraseOn&&selected('name')?'Incluído':'+ R$ 30');
        priceLabel('number',phraseOn&&selected('number')?'Incluído':'+ R$ 20');
      }

      if(phraseHelper){
        const len=phraseLength();
        if(isBrazil){
          phraseHelper.textContent=`${len}/130 caracteres · grátis nesta camisa do Brasil.`;
        }else{
          const faixa=len>80?'R$ 100':'R$ 70';
          phraseHelper.textContent=`${len}/130 caracteres · ${faixa}. Nome e número podem ser incluídos sem custo extra.`;
        }
      }

      const base=Number(currentVariant()?.price||0);
      if(baseEl)baseEl.textContent=money.format(base/100);
      if(addonEl)addonEl.textContent=isBrazil?'GRÁTIS':money.format(extra/100);
      if(grandEl)grandEl.textContent=money.format((base+extra)/100);
      if(error){error.hidden=true;error.textContent=''}
    }

    toggles.forEach(t=>t.addEventListener('change',update));
    phraseInput?.addEventListener('input',update);
    form.addEventListener('change',e=>{
      if(e.target?.name==='id'||e.target?.closest?.('variant-selects,variant-radios'))setTimeout(update,0)
    });
    document.addEventListener('change',e=>{
      if(e.target?.name==='id'&&e.target.form===form)setTimeout(update,0)
    });

    form.addEventListener('submit',async e=>{
      if(!toggles.some(t=>t.checked))return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const values={
        name:clean(input('name')?.value),
        number:clean(input('number')?.value),
        phrase:clean(input('phrase')?.value)
      };
      const labels={name:'nome',number:'número',phrase:'frase'};

      for(const key of Object.keys(values)){
        if(selected(key)&&!values[key]){
          if(error){
            error.textContent=`Preencha o ${labels[key]} escolhido antes de adicionar ao carrinho.`;
            error.hidden=false;
          }
          input(key)?.focus();
          return;
        }
      }

      if(selected('phrase')&&values.phrase.length>130){
        if(error){error.textContent='A frase pode ter no máximo 130 caracteres.';error.hidden=false}
        phraseInput?.focus();
        return;
      }

      const variantId=Number(form.querySelector('[name="id"]')?.value);
      const qField=form.querySelector('[name="quantity"]')||document.querySelector(`[name="quantity"][form="${formId}"]`);
      const quantity=Math.max(1,Number(qField?.value||1));
      if(!variantId){
        if(error){error.textContent='Escolha um tamanho disponível antes de continuar.';error.hidden=false}
        return;
      }

      const selectedVariant=variants.find(v=>String(v.id)===String(variantId));
      if(selectedVariant&&selectedVariant.available===false){
        if(error){error.textContent='Este tamanho não está disponível. Escolha outro tamanho.';error.hidden=false}
        return;
      }

      const props={};
      if(selected('name'))props['Nome']=values.name;
      if(selected('number'))props['Número']=values.number;
      if(selected('phrase'))props['Frase']=values.phrase;
      if(isBrazil&&Object.keys(props).length)props['_Personalização grátis']='Brasil';
      const items=[{id:variantId,quantity,properties:props}];

      if(!isBrazil){
        if(selected('phrase')){
          const phraseVariant=values.phrase.length>80?PHRASE_LONG_VARIANT:PHRASE_SHORT_VARIANT;
          const addonProps={
            '_Aplicado em':root.dataset.productTitle,
            '_Produto principal':root.dataset.productId,
            '_Texto':values.phrase
          };
          if(selected('name'))addonProps['_Nome incluído']=values.name;
          if(selected('number'))addonProps['_Número incluído']=values.number;
          items.push({id:phraseVariant,quantity,properties:addonProps});
        }else{
          const addonMap={
            name:Number(root.dataset.addonName),
            number:Number(root.dataset.addonNumber)
          };
          Object.keys(addonMap).forEach(key=>{
            if(selected(key)&&addonMap[key]){
              items.push({
                id:addonMap[key],
                quantity,
                properties:{
                  '_Aplicado em':root.dataset.productTitle,
                  '_Produto principal':root.dataset.productId,
                  '_Texto':values[key]
                }
              });
            }
          });
        }
      }

      const button=form.querySelector('[name="add"]');
      const original=button?.querySelector('span')?.textContent;
      if(button){
        button.disabled=true;
        button.classList.add('loading');
        const span=button.querySelector('span');
        if(span)span.textContent='Adicionando...';
      }

      try{
        const res=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        const data=await res.json();
        if(!res.ok)throw new Error(data?.description||data?.message||'Não foi possível adicionar a personalização.');
        window.location.href=(window.Shopify?.routes?.root||'/')+'cart';
      }catch(err){
        let message=err?.message||'Não foi possível adicionar ao carrinho. Tente novamente.';
        if(/cannot find variant/i.test(message))message='Não foi possível localizar uma das opções selecionadas. Atualize a página, escolha novamente o tamanho e tente de novo.';
        if(error){error.textContent=message;error.hidden=false}
        if(button){
          button.disabled=false;
          button.classList.remove('loading');
          const span=button.querySelector('span');
          if(span&&original)span.textContent=original;
        }
      }
    },true);

    update();
  }

  function boot(){document.querySelectorAll('[data-lf-customizer]').forEach(init)}
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  if(document.readyState!=='loading')boot();
})();